import './spinner.css'
import React from 'react';

/**
 * Pure CSS spinner from https://loading.io/css/
 */
function Spinner() {
  return (
    <div className="lds-dual-ring"></div>
  );
}

export default Spinner;
